import { useState } from "react";
import { motion } from "framer-motion";
import styles from "../styles/layout/Header.module.css";
import LanguageSwitcher from "./LanguageSwitcher";

function Header() {
  const [isCrazy, setIsCrazy] = useState(false);

  const handleToggle = () => {
    setIsCrazy((prev) => !prev);
  };

  return (
    <header className={styles.header}>
      <div className={styles.headerControls}>
      <div className={styles.toggleContainer}>
        <label
          className={`${styles.toggleLabel} ${isCrazy ? styles.active : ""}`}
        >
          <input
            type="checkbox"
            className={styles.toggleCheckbox}
            checked={isCrazy}
            onChange={handleToggle}
          />
          <motion.span
            className={styles.icon}
            initial={{ rotate: 0 }}
            animate={{
              left: isCrazy ? 43 : 4,
              rotate: isCrazy ? 360 : 0, // вращение на 360° при включении
            }}
            transition={{
              type: "spring",
              stiffness: 300,
              damping: 25,
              rotate: { duration: 0.6 }, // скорость вращения
            }}
          >
            <span className={styles.emoji}>💡</span>
          </motion.span>

        </label>
      </div>
      <div className={styles.toggleContainer}>
       
      </div>
      <LanguageSwitcher />
      </div>
    </header>
  );
}

export default Header;
